import { render, staticRenderFns } from "./TalentBio.vue?vue&type=template&id=010879da&scoped=true"
import script from "./TalentBio.vue?vue&type=script&lang=js"
export * from "./TalentBio.vue?vue&type=script&lang=js"
import style0 from "./TalentBio.vue?vue&type=style&index=0&id=010879da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010879da",
  null
  
)

export default component.exports